import {
  ToggleButton, ToggleButtonGroup,
} from '@mui/material';

interface ToggleFixedAspectProps {
  value: boolean;
  handleChange: (value: boolean) => void;
}

const ToggleFixedAspect = ({ value, handleChange }: ToggleFixedAspectProps) => (
    <ToggleButtonGroup
      size="small"
      color="primary"
      value={value}
      exclusive
      onChange={(event, value) => handleChange(value)}
    >
      <ToggleButton value>比率を固定する</ToggleButton>
      <ToggleButton value={false}>画像に合わせる</ToggleButton>
    </ToggleButtonGroup>
);

export default ToggleFixedAspect;
